@if (tooltipText) {
	<div
		[ngbTooltip]="navItemTooltip"
		class="svg-icon icon-{{ name }} {{ hasMargin ? 'has-margin' : '' }}"
		(click)="onIconClick()"
	></div>
}
@if (!tooltipText) {
	<div
		class="svg-icon icon-{{ name }} {{ hasMargin ? 'has-margin' : '' }}"
		(click)="onIconClick()"
	></div>
}

<ng-template #navItemTooltip>
	{{ tooltipText }}
</ng-template>
